import { useContext, useState } from 'react';
import { OutpostAttempt } from '../../../../../../../typings/outpost';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { useToasts } from '../../../common/Toast';
const useOperatorEventRetryAttempt = (on_retried?: () => void | Promise<void>) => {
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const [retrying_attempt_id, setRetryingAttemptId] = useState<string>();
  const retryAttempt = async (attempt: OutpostAttempt) => {
    if (retrying_attempt_id === attempt.id) {
      return;
    }
    try {
      setRetryingAttemptId(attempt.id);
      await HookdeckAPI.outpost.operatorEvents.retries.retry(attempt.event_id, attempt.destination_id);
      addToast('success', 'Retrying delivery');
      await on_retried?.();
    } catch {
      addToast('error', 'Failed to retry delivery');
    } finally {
      setRetryingAttemptId(undefined);
    }
  };
  return {
    retryAttempt,
    retrying_attempt_id
  };
};
export default useOperatorEventRetryAttempt;